import cn from 'classnames';
import { IoClose } from 'react-icons/io5';
import ReactModal from 'react-modal';

import AddressSelection from '../AddressSelection/AddressSelection';
import modalStyles from '../GenericModal/GenericModal.module.scss';

import styles from './AddressSelectionModal.module.scss';

export default function AddressSelectionModal({ isOpen, setIsOpen }) {
  return (
    <ReactModal
      className={modalStyles.content}
      overlayClassName={modalStyles.overlay}
      portalClassName={styles.modal}
      isOpen={isOpen}
      onRequestClose={setIsOpen}
      contentLabel="Επιλογή διεύθυνσης παράδοσης"
      ariaHideApp={false}
    >
      <div className={cn(styles.header, modalStyles.headerClass)}>
        <div>
          <h3 className={styles.modalHeader} key={1}>
            Επίλεξε διεύθυνση παράδοσης
          </h3>
        </div>
        <button type="button" className={styles.close} onClick={() => setIsOpen(false)}>
          <IoClose className={modalStyles.closeSymbol} />
        </button>
      </div>

      <div className={cn([styles.body, 'fullBody'])}>
        <div className={styles.container}>
          <AddressSelection setIsOpen={setIsOpen} />
        </div>
      </div>

      <div className={styles.footer} />
    </ReactModal>
  );
}
